import { ThemeEvents, VariantUpdateEvent} from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    this.closestSection = this.closest('.accessory-product, .shopify-section, dialog');
    if (!this.closestSection) return;
    this.closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    if (!this.closestSection) return;
    this.closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    const source = event.detail.data.html;
    const productId = event.detail.data.productId;

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newProductPrice = source.querySelector(`product-price[data-product-id="${productId}"]`);
    const newPrice = newProductPrice?.innerHTML;

    let currentPrice = this.innerHTML;

    if (!newPrice || !currentPrice) return;

    if (currentPrice !== newPrice) {
      this.innerHTML = newPrice;
    }

    // Scope to the matching product to avoid duplicating the save-amount price
    const newSaveAmount = newProductPrice.querySelector('.save-amount-wrapper')?.cloneNode(true);
    const currentSaveAmounts = this.querySelectorAll('.save-amount-wrapper');

    for (const saveAmount of currentSaveAmounts) saveAmount.remove();

    if (newSaveAmount) this.appendChild(newSaveAmount);
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
